import RequestCallButton from "../CallReqButton";
import "./index.css";
import Marquee from "react-fast-marquee";

// const logos = [
//   "https://iqteche.in/static/media/wl_client_images/4e31341c5f874122814b2b95f1b3c3d7.png",
//   "https://iqteche.in/static/media/wl_client_images/c843eccade7a46889062b6a4864eb1d9.png",
//   "https://iqteche.in/static/media/wl_client_images/dab02524c3384f6386e9175eb0bce288.png",
//   "https://iqteche.in/static/media/wl_client_images/b1a71e2b2e854de0a36d4b0135147ddb.png",
//   "https://iqteche.in/static/media/wl_client_images/a2fbb213c85744c3a3d73c2f0b6e2f05.png",
//   "https://iqteche.in/static/media/wl_client_images/0535bd80252d44c0b304e9648ec3f08e.png",
//   "https://iqteche.in/static/media/wl_client_images/27e602bc41d94a6397e6b85ae6dc5da5.png",
//   "https://iqteche.in/static/media/wl_client_images/2e31b09390e34a2e9b1f433ba18788b1.png",
//   "https://iqteche.in/static/media/wl_client_images/95eda64131264bf5a6e988b3e49c5bcd.png",
//   "https://iqteche.in/static/media/wl_client_images/e0d60ed1cc554c80b82eb5fd16f7a67a.png",
//   // "https://iqteche.in/static/media/wl_client_images/18799ad1523d426a85e2954b46fca0a7.png",
//   // "https://iqteche.in/static/media/wl_client_images/b7c18f8d8bf64d0e92b3573b5fdeb437.png",
//   // "https://iqteche.in/static/media/wl_client_images/22f6219dcff84598bc8a1393aca5320c.png",
// ];

// const logos2 = [
//   "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/6c585c33ca6c71c79bb7.png",
//   "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/9dd55e54b5a28658bf4e.png",
//   "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/0384060dcbf73b6a707c.png",
//   "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/35e044b3354aaa0caed5.png",
//   "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/f50ae7cbf6cc805bdadc.png",
//   "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/6c585c33ca6c71c79bb7.png",
// ];

const companyLogos = [
  "https://iqteche.in/static/media/wl_client_images/415a21c21982461dac64180a9000f623.png",
  "https://iqteche.in/static/media/wl_client_images/269e34fc918b46a5ac331e54a46c361e.png",
  "https://iqteche.in/static/media/wl_client_images/adf525ea6c064bd0a25bf0f2fa86d874.png",
  "https://iqteche.in/static/media/wl_client_images/35513a5837c444dd901cf92754a8431a.png",
  "https://iqteche.in/static/media/wl_client_images/7d5c2a5b4ccb42d0b1fbef10f1242387.png",
  "https://iqteche.in/static/media/wl_client_images/3c2739eebf4d42c397389f153576114f.png",
  "https://iqteche.in/static/media/wl_client_images/1db7a9c28da0455b9ff87dac52aeb4f0.png",
  "https://iqteche.in/static/media/wl_client_images/a21088560e704f31b6f97a4bf38dd9c1.png",
  "https://iqteche.in/static/media/wl_client_images/64340e0b72544e6b9e52e83d8eea5514.png",
  "https://iqteche.in/static/media/wl_client_images/5895e836cc4b4a3e93868135db1dd1d4.png",
  "https://iqteche.in/static/media/wl_client_images/631044af45b1419e9268edf9cc161b58.png",
  "https://iqteche.in/static/media/wl_client_images/04648e16d4934cb4808c30a7d95ef23e.png",
  "https://iqteche.in/static/media/wl_client_images/51fc9461e9354657ac94ae5fc5696985.png",
  "https://iqteche.in/static/media/wl_client_images/f8de4a3885414536a63fbf584285befa.png",
  "https://iqteche.in/static/media/wl_client_images/cc5a5f27a62c45389761b10da4430056.png",
  "https://iqteche.in/static/media/wl_client_images/362497cd73cd49eb9a870963e65355cf.png",
  "https://iqteche.in/static/media/wl_client_images/bd5bf7098ddf4221b45eede3b3aeca23.png",
  "https://iqteche.in/static/media/wl_client_images/1ac40ba769234f6f947c5212aa9d2fe0.png",
  "https://iqteche.in/static/media/wl_client_images/1d0e8968b48b4358b2db37b3e46f65ff.png",
  "https://iqteche.in/static/media/wl_client_images/8ea661f0da3a493c9afe4731b7dd0254.png",
];

const ScrollingLogos = () => {
  return (
    <Marquee direction="right" speed={100} delay={5} className="pb-5">
      {companyLogos.map((logo, index) => (
        <div className="image_wrapper shadow" key={index}>
          <img src={logo} alt={`Company logo ${index + 1}`} />
        </div>
      ))}
    </Marquee>
  );
};

const TrustedByCompanies = () => {
  return (
    <div className="trusted-companies-logo-container text-center ">
      <h1 className="company-section-heading">
        IBIX Students Hired by Leading
        <br />
        <span className="company-heading-span"> 350+</span> Companies
      </h1>

      <img
        className="all-companies-img"
        src="https://iqteche.in/static/media/wl_client_images/05107b644bd54b31a3968a1450dadb45.png"
        alt="companies"
      />

      <ScrollingLogos />
      <RequestCallButton />
    </div>
  );
};

export default TrustedByCompanies;
